<template>
  <div class="investor">
    <UserAvatar
      :image="item.logoImageUrl"
      :name="item.displayName"
      :email="item.displayName"
      size="large"
      transparent
    />

    <div class="name">{{ item.displayName }}</div>

    <b-button v-if="item.isEditable" variant="link" @click="$emit('edit', item)"
      >Edit</b-button
    >
    <b-button variant="link" @click="$emit('remove', item)">Remove</b-button>
  </div>
</template>

<script>
import UserAvatar from '@/components/user/UserAvatar'

export default {
  components: {
    UserAvatar
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.investor {
  display: flex;
  align-items: center;

  .name {
    padding: 0 20px;
    flex: 1 1 auto;
  }

  /deep/.btn {
    padding: 5px 10px;
  }
}
</style>
